import {
  Card,
  CardActions,
  CardContent,
  Divider,
  List,
  ListItemText,
  Typography,
} from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  prettyDuration,
  prettyFullTimestamp,
} from '../../../utils/datetimeUtils'

import { ReactNode } from 'react'
import { formatPrettyCurrency } from '../../../components/prettyCurrency'
import InvoiceForm from './invoiceForm'

type CardInvoiceProps = {
  invoiceNumber: string
  locationName: string
  startTimeISO: string
  duration: number
  price: number
  vat: number
  vatPrice: number
  isButtonDisabled: boolean
  onInvoiceClick: (userEmail: string) => void
}

const CardInvoice = ({
  invoiceNumber,
  locationName,
  startTimeISO,
  duration,
  price,
  vat,
  vatPrice,
  isButtonDisabled,
  onInvoiceClick,
}: CardInvoiceProps) => {
  const TitleValue = ({
    title,
    value,
  }: {
    title: ReactNode
    value: string
  }) => {
    return (
      <>
        {title}
        {': '}
        <b>{value}</b>
      </>
    )
  }
  const intl = useIntl()

  return (
    <Card sx={{ minWidth: 200 }} key={invoiceNumber}>
      <CardContent>
        <List>
          <ListItemText style={{ wordBreak: 'break-all' }}>
            <Typography variant="h5" textAlign="left">
              {locationName}
            </Typography>
          </ListItemText>
        </List>
        <List style={{ paddingBottom: 0, paddingTop: 0, textAlign: 'left' }}>
          <ListItemText style={{ wordBreak: 'break-all' }}>
            <TitleValue
              title={
                <FormattedMessage id="page.webPayment.stepInvoice.cardInvoice.parkingStarted" />
              }
              value={prettyFullTimestamp(intl, startTimeISO)}
            />
          </ListItemText>
          <ListItemText style={{ wordBreak: 'break-all' }}>
            <TitleValue
              title={
                <FormattedMessage id="page.webPayment.stepInvoice.cardInvoice.duration" />
              }
              value={prettyDuration(intl, duration)}
            />
          </ListItemText>
        </List>
        <List>
          <ListItemText style={{ wordBreak: 'break-all' }}>
            <Divider />
          </ListItemText>
        </List>
        <List style={{ paddingBottom: 0, paddingTop: 0, textAlign: 'left' }}>
          <ListItemText style={{ wordBreak: 'break-all' }}>
            <TitleValue
              title={
                <FormattedMessage id="page.webPayment.stepInvoice.cardInvoice.parkingPrice" />
              }
              value={formatPrettyCurrency({ intl, cents: price }) || ''}
            />
          </ListItemText>
          <ListItemText style={{ wordBreak: 'break-all' }}>
            <Typography sx={{ fontStyle: 'italic' }}>
              <FormattedMessage
                id="page.webPayment.stepInvoice.cardInvoice.vatIncluded"
                values={{
                  vat: intl.formatNumber(vat),
                  vatPrice: formatPrettyCurrency({ intl, cents: vatPrice }),
                }}
              />
            </Typography>
          </ListItemText>
        </List>
      </CardContent>
      <CardActions style={{ paddingBottom: 10 }}>
        <InvoiceForm
          onSubmit={onInvoiceClick}
          isButtonDisabled={isButtonDisabled}
        />
      </CardActions>
    </Card>
  )
}

export default CardInvoice
